import { Route } from '@angular/router';

// 기본 레이아웃에서 사용되는 상품 라우트 (목록, 폼)
export const ProductRoutes: Route[] = [
  {
    path: 'product',
    children: [
      {
        path: '',
        loadComponent: () => import('../pages/product/product.page'),
      },
      {
        path: 'form',
        loadComponent: () =>
          import('../pages/product/product-form/product-form.page'),
      },
      {
        path: 'form/:id',
        loadComponent: () =>
          import('../pages/product/product-form/product-form.page'),
      },
    ],
  },
];
